// On a phone, a card is flat and reaches the screen edges (the page's px-4 gutter). Each card
// says how it drops its shadow.
export const FLAT_ON_PHONE = "max-sm:-mx-4 max-sm:rounded-none max-sm:border-x-0";

// On a phone, a primary or only-way control is a 40px tap target.
export const TAP_ON_PHONE = "max-sm:h-10";

// A control that stays focusable while it can't act (aria-disabled plus a guarded handler).
export const ARIA_DISABLED_LOOK = "aria-disabled:cursor-not-allowed aria-disabled:opacity-50";

// The dialog's corner Close: a 36px hit area around the same 16px icon, in the same place.
// Depends on Close being DialogContent's last child (components/ui/dialog renders it after children).
export const DIALOG_CLOSE_TARGET =
  "[&>button:last-child]:right-1.5 [&>button:last-child]:top-1.5 [&>button:last-child]:p-2.5";

/** Dialogs open on their main control (marked data-autofocus), not on the corner Close. */
export function focusMainControl(event: Event) {
  const main = (event.currentTarget as HTMLElement | null)?.querySelector<HTMLElement>(
    "[data-autofocus]"
  );
  if (!main) return;
  event.preventDefault();
  main.focus();
}
